(() => {
  const modal = document.getElementById('SearchModal');
  if (!modal || typeof modal.showModal !== 'function') return;
  const input = modal.querySelector('[data-search-input]');
  const list = modal.querySelector('[data-search-results]');
  const hint = modal.querySelector('[data-search-hint]');
  const form = modal.querySelector('form');
  const currency = modal.dataset.currency || '';
  const searchUrl = modal.dataset.searchUrl;
  const CACHE_KEY = 'search-index-v3';
  const CACHE_TTL = 10 * 60 * 1000;
  let index = null, loading = null, active = -1, shown = [];

  // --- normalizácia: malé písmená, bez diakritiky ---
  const norm = s => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const words = s => norm(s).split(/[^a-z0-9]+/).filter(Boolean);

  let cols = [];
  try {
    cols = JSON.parse(document.getElementById('SearchCollections').textContent).map(c => ({
      title: c.title, url: c.url, image: c.image, price: null, isCollection: true,
      titleWords: words(c.title), otherWords: words(c.vendor),
    }));
  } catch (e) {}

  // Levenshtein s ranným ukončením nad limit
  const lev = (a, b, max) => {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    let prev = Array.from({ length: b.length + 1 }, (_, i) => i);
    for (let i = 1; i <= a.length; i++) {
      const cur = [i]; let rowMin = i;
      for (let j = 1; j <= b.length; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        if (cur[j] < rowMin) rowMin = cur[j];
      }
      if (rowMin > max) return max + 1;
      prev = cur;
    }
    return prev[b.length];
  };

  // skóre jedného tokenu voči slovám produktu (0 = nezhoda)
  const tokenScore = (t, ws) => {
    let best = 0;
    for (const w of ws) {
      let s = 0;
      if (w === t) s = 100;
      else if (w.startsWith(t)) s = 80 - Math.min(20, w.length - t.length);
      else if (t.length >= 3 && w.includes(t)) s = 50;
      else if (t.length >= 3) {
        const max = t.length >= 7 ? 2 : 1;
        // preklep – porovnaj s rovnako dlhou predponou slova aj s celým slovom
        const d = Math.min(lev(t, w, max), lev(t, w.slice(0, t.length), max));
        if (d <= max) s = 40 - d * 10;
      }
      if (s > best) best = s;
    }
    return best;
  };

  const search = q => {
    const tokens = words(q);
    if (!tokens.length || !index) return [];
    const out = [];
    for (const p of [...cols, ...index]) {
      let total = 0, ok = true;
      for (const t of tokens) {
        // názov váži viac než ostatné polia
        const s = Math.max(tokenScore(t, p.titleWords) * 1.5, tokenScore(t, p.otherWords));
        if (!s) { ok = false; break; }
        total += s;
      }
      if (ok) out.push({ p, score: total });
    }
    return out.sort((a, b) => b.score - a.score).slice(0, 8).map(r => r.p);
  };

  // --- načítanie katalógu (raz, potom sessionStorage) ---
  const prep = r => r.map(p => ({
    title: p.title, url: '/products/' + p.handle,
    image: p.images && p.images[0] ? p.images[0].src : '',
    price: p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : null,
    was: p.variants && p.variants[0] && p.variants[0].compare_at_price ? parseFloat(p.variants[0].compare_at_price) : null,
    titleWords: words(p.title),
    otherWords: words([p.product_type, p.vendor, (p.tags || []).join(' ')].join(' ')),
  }));

  const load = () => {
    if (index) return Promise.resolve();
    if (loading) return loading;
    try {
      const cached = JSON.parse(sessionStorage.getItem(CACHE_KEY));
      if (cached && Date.now() - cached.t < CACHE_TTL) { index = cached.index; return Promise.resolve(); }
    } catch (e) {}
    loading = (async () => {
      const all = [];
      for (let page = 1; page <= 10; page++) {
        const res = await fetch('/collections/all/products.json?limit=250&page=' + page);
        if (!res.ok) break;
        const data = await res.json();
        all.push(...data.products);
        if (data.products.length < 250) break;
      }
      index = prep(all);
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), index })); } catch (e) {}
    })().catch(() => { index = []; });
    return loading;
  };

  // --- vykreslenie ---
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const setActive = i => {
    active = i;
    [...list.children].forEach((li, n) => li.classList.toggle('is-active', n === i));
    const el = list.children[i]; if (el) el.scrollIntoView({ block: 'nearest' });
  };

  const render = () => {
    const q = input.value.trim();
    shown = search(q);
    list.innerHTML = shown.map(p => `<li role="option"><a href="${esc(p.url)}">
      <span class="smodal__img">${p.image ? `<img src="${esc(p.image)}" alt="" loading="lazy" width="48" height="48">` : ''}</span>
      <span class="smodal__title">${esc(p.title)}</span>
      ${p.isCollection ? '<span class="smodal__price">Séria</span>' : ''}
      ${p.price != null ? `<span class="smodal__price">${p.was > p.price ? `<s>${p.was.toFixed(2).replace('.', ',')}</s> ` : ''}od ${p.price.toFixed(2).replace('.', ',')} ${esc(currency)}</span>` : ''}
    </a></li>`).join('');
    hint.textContent = !q ? 'Začnite písať – hľadanie toleruje preklepy aj chýbajúcu diakritiku.' : 'Nič sa nenašlo. Stlačte Enter pre úplné vyhľadávanie.';
    hint.hidden = !!shown.length;
    setActive(shown.length ? 0 : -1);
  };

  // --- otvorenie / zatvorenie ---
  const open = () => {
    if (!modal.open) modal.showModal();
    input.focus(); input.select();
    load().then(render);
  };
  const close = () => modal.open && modal.close();

  document.addEventListener('click', e => {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); open(); }
  });
  // klik (nie focus – po zatvorení dialógu sa focus vracia na pole a okno by sa otvorilo znova)
  document.addEventListener('click', e => {
    if (e.target.matches('.header__search input')) open();
  });
  document.addEventListener('keydown', e => {
    if (e.target.matches('.header__search input') && e.key === 'Enter') { e.preventDefault(); open(); }
  });
  document.addEventListener('keydown', e => {
    if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); open(); }
  });
  modal.addEventListener('click', e => { if (e.target === modal || e.target.closest('[data-search-close]')) close(); });

  input.addEventListener('input', render);
  input.addEventListener('keydown', e => {
    if (e.key === 'ArrowDown' && shown.length) { e.preventDefault(); setActive((active + 1) % shown.length); }
    else if (e.key === 'ArrowUp' && shown.length) { e.preventDefault(); setActive((active - 1 + shown.length) % shown.length); }
  });
  form.addEventListener('submit', e => {
    // Enter otvorí vybraný produkt; bez výberu ide na stránku s výsledkami
    if (active >= 0 && shown[active] && input.value.trim()) { e.preventDefault(); location.href = shown[active].url; }
  });
})();
